<template>
    <header-helper id="past-months">Past 3 Months Gross Revenue and Potential</header-helper>
</template>

<script>
import HeaderHelper from 'src/components/GrossesHeader/HeaderHelper';

export default {
    components: {
        HeaderHelper,
    },
};
</script>
